import React, { useEffect, useState } from "react";
import "./Order_Placed_Page.css";
import { Button, Modal } from "react-bootstrap";
// import Successfull_Lottie from "../../../Animation/Successfull_Lottie/Successfull_Lottie";
// import Celebrate_Lottie from "../../../Animation/Celebrate_Lottie/Celebrate_Lottie";
import { Link, useNavigate, useParams } from "react-router-dom";

import Green_Btn from "../common-components/common_btn/green_btn/Green_btn";
import Red_Outline_Btn from "../common-components/common_btn/red_outline_btn/Red_Outline_Btn";
import Successfull_Lottie from "../Animation/Successfull_Lottie/Successfull_Lottie";
import OrderPlacedSuccessfullModal from "../common-components/common_modal/OrderPlacedSuccessfullModal/OrderPlacedSuccessfullModal";
import { useDispatch } from "react-redux";
import { OrderResponse } from "../../features/order/orderSlice";

function Order_Failed_Page({ baseLink, handleManualClose, ...props }) {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate("/");
  };

  const handleContinueShopping = () => {
    navigate("/product-listing-sub-category");
  };

  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const params = new URLSearchParams(window.location.search);
  const merchantOrderId = params.get("merchantOrderId");
  const OrderId = params.get("OrderId");

  // useEffect(() => {
  //   const orderResponse = async (merchantOrderId) => {
  //     const data = { merchantOrderId };
  //     const res = await dispatch(OrderResponse(data));

  //     if (res.meta?.requestStatus === "fulfilled") {
  //       // success logic
  //     } else if (res.meta?.requestStatus === "rejected") {
  //       // handle error
  //     }
  //   };

  //   if (merchantOrderId) {
  //     orderResponse(merchantOrderId);
  //   }
  // }, []);
  const handleViewDetails = () => {
    navigate(`/order-details/${OrderId}`);
  };

  return (
    <section className="Order_Placed_Page modal-holder">
      {/* <Red_Outline_Btn
                btn_name="Go to Home"
                onClick={() => setShowModal(true)}
              /> */}

      <div className="container">
        <div className="success_main_div">
          <div className="celebrate_lottie_holder"></div>
          <div className="success_loottie_holder">
            <Successfull_Lottie />
          </div>

          <div className="success_content_holder">
            <div className="text_holder">
              <p className="heading">Order Payment Failed</p>
              {/* <p className="sub_text">
                Order placed successfully your product will be <br /> delivered
                soon.
              </p> */}
            </div>
          </div>

          <div className="text-center btn_holder">
            <div className="home_btn">
              <Red_Outline_Btn
                btn_name="Go to Home"
                onClick={handleHomeClick}
              />
            </div>
            <div className="continue_btn">
              <Green_Btn
                btn_name="Continue Shopping"
                onClick={handleContinueShopping}
              />
            </div>
          </div>

          {/* <div className="track_order_div">
            <div className="left_side_div">
              <div className="text_holder">
                <div className="title">
                  <p>Track Your Order</p>
                </div>
                <div className="footer_text">
                  <p>Rider will be assigned soon</p>
                </div>
              </div>
            </div>

            <div className="right_side">
              <div className="text-center btn_holder">
                <Green_Btn
                  btn_name="View Details"
                  onClick={handleViewDetails}
                />
              </div>
            </div>
          </div> */}
        </div>
      </div>

      <OrderPlacedSuccessfullModal
        // handleManualClose={handleManualClose}
        // handleClick={handleClick}
        show={showModal}
        onHide={() => setShowModal(false)}
        // baseLink={`/order-details/${trackId?.id}`}
      />
    </section>
  );
}

export default Order_Failed_Page;

// export default OrderPlacedSuccessfullModal;
